import {
  FETCH_ADVISOR_LISTINGS,
  FETCH_ADVISOR_DETAILS,
  FETCH_ADMIN_ADVISOR_LISTINGS,
  FETCH_ADVISOR_LISTINGS_STARTED,
  EDITADVISOR,
  SELECT_PLAN,
  RESETFORMS,
} from './types';
import advisorService from '../../common/services/advisorService';

export const fetchAdvisorListings = (pageNumber = 1) => dispatch => {
  advisorService.getAdvisors(pageNumber).then(
    res => {
      dispatch({
        type: FETCH_ADVISOR_LISTINGS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_ADVISOR_LISTINGS,
        payload: { data: [] },
      });
    },
  );
};

export const fetchAdvisorDetails = id => dispatch => {
  advisorService.getAdvisor(id).then(
    res => {
      dispatch({
        type: FETCH_ADVISOR_DETAILS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_ADVISOR_DETAILS,
        payload: {},
      });
    },
  );
};

export const editAdvisor = id => dispatch => {
  advisorService.getAdvisor(id, true).then(
    res => {
      dispatch({
        type: EDITADVISOR,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: EDITADVISOR,
        payload: {},
      });
    },
  );
};

export const resetForm = () => dispatch => {
  dispatch({ type: RESETFORMS });
};

export const fetchAdminAdvisorListings = (pageNumber = 1) => dispatch => {
  dispatch({ type: FETCH_ADVISOR_LISTINGS_STARTED });
  advisorService.getAdminAdvisorListings(pageNumber).then(
    res => {
      dispatch({
        type: FETCH_ADMIN_ADVISOR_LISTINGS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_ADMIN_ADVISOR_LISTINGS,
        payload: { data: [] },
      });
    },
  );
};

export const searchAdminAdvisorListings = (
  startDate,
  endDate,
  searchQuery,
  status,
  byId,
  pageNumber = 1,
) => async dispatch => {
  dispatch({ type: FETCH_ADVISOR_LISTINGS_STARTED });
  await advisorService
    .searchAdminAdvisorListings(
      startDate,
      endDate,
      searchQuery,
      status,
      byId,
      pageNumber,
    )
    .then(
      res => {
        dispatch({
          type: FETCH_ADMIN_ADVISOR_LISTINGS,
          payload: res.data,
        });
      },
      err => {
        dispatch({
          type: FETCH_ADMIN_ADVISOR_LISTINGS,
          payload: { data: [] },
        });
      },
    );
};

export const selectPlan = plan => dispatch => {
  dispatch({
    type: SELECT_PLAN,
    payload: plan,
  });
};
